export const setCookie = (
  cookieName: string,
  cookieValue: string,
  hoursToExpire: number,
  extraParams?: string,
) => {
  const date = new Date();
  date.setTime(date.getTime() + hoursToExpire * 60 * 60 * 1000);
  document.cookie = `${cookieName} = ${cookieValue}; expires = ${date.toUTCString()}${
    extraParams ? `; ${extraParams}` : ''
  }`;
};

export const getCookie = (cookieName: string) => {
  const allCookies = document.cookie;
  return allCookies
    .split('; ')
    .find((row) => row.startsWith(cookieName))
    ?.split('=')[1];
};

export const deleteCookie = (cookieName: string) => {
  if (getCookie(cookieName)) {
    setCookie(cookieName, '', 0);
  }
};
